export const THREE_AXIS_WIDGETS_TYPES = {
    Bubble: 'bubble',
    Variwide: 'variwide',
};
